import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';

/**
 * Small refresh control for cached list pages. Spins while a forced refetch
 * is in flight; the list stays visible behind it.
 * @param {{ onRefresh: () => void, refreshing?: boolean, title?: string }} props
 */
export default function RefreshButton({ onRefresh, refreshing = false, title = 'Refresh' }) {
  return (
    <button
      type="button"
      onClick={onRefresh}
      disabled={refreshing}
      title={title}
      aria-label={title}
      className="p-2 rounded-full text-gray-500 hover:text-gray-700 hover:bg-gray-100 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
    >
      <FiRefreshCw size={18} className={refreshing ? 'animate-spin' : ''} />
    </button>
  );
}
